import EditIcon from '@mui/icons-material/Edit'
import { Box, IconButton, Tab, Tabs } from '@mui/material'
import { IEvent, IEventStatus, ISport } from 'bets.oddprovider.lib.common.ts/models'
import { endOfDay, startOfDay } from 'date-fns'
import { NumberUtils } from 'fwork-jsts-common/src'
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import moment from 'moment'
import { FilterQuery } from 'mongoose'
import { useSnackbar } from 'notistack'
import * as React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { EventsStatusApiClient } from '../../apiClient/eventsStatus'
import { SportsApiClient } from '../../apiClient/sports'
import { DEFAULTGAP, RoutesNames } from '../../globals'
import { IEventsState, eventsStateLoadFromApi } from '../../redux/reducers/events.slice'
import { toggleLoading } from '../../redux/reducers/loadingBar.slice'
import { RootState } from '../../redux/store'
import { DropDownSearchComponent } from '../common/dropDownSearch'
import { HeaderComponent } from '../common/header'
import { SearchInputComponent } from '../common/searchInput'
// import { TableComponent } from '../common/table'
// import { StyledListItemText, StyledTableCell, TableComponentSetCurrPageProps } from '../common/table/common'
import { FormItemStyled, FormStyled, StyledListItemText, StyledTableCell, TableComponent, TableComponentSetCurrPageProps } from 'fwork.react.apptemplate'
import axios from '../../apiClient/axios'
import { default as imageDefaultAvatar } from '../../assets/avatar.jpg'
import { DateTimePickerExtComponent } from '../common/datePicker'
import { EventsParticipantComponent } from './eventsParticipant'

interface SearchOptionsProps {
  text?: string | undefined,
  sportId?: number | undefined,
  statusId?: number | undefined,
  dtIni?: Date | undefined,
  dtFin?: Date | undefined,
}

export const EventsComponent = () => {
  // IMPORTED METHOD
  const tableComponentSetCurrPageRef = React.useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current
  // ...IMPORTED METHOD

  const eventsState: IEventsState = useSelector((state: RootState) => state.eventsState)
  const events = [...eventsState.payload || []]
  const navigate = useNavigate()
  const dispatch = useDispatch<any>()
  const { enqueueSnackbar } = useSnackbar()

  const [sportTabValue, setSportTabValue] = useState<number>(0)
  const [currSportId, setCurrSportId] = useState<number>()

  const [searchOptions, setSearchOptions] = useState<SearchOptionsProps | undefined>({
    dtIni: new Date(eventsState.filter?.$and?.filter(and => and.start_date)[0]?.start_date?.$gte?.value || startOfDay(new Date())),
    dtFin: new Date(eventsState.filter?.$and?.filter(and => and.start_date)[0]?.start_date?.$lte?.value || endOfDay(new Date()))
  })

  React.useEffect(() => {
    if (eventsState.sports?.length)
      setCurrSportId(eventsState.sports[0].id)
    setSportTabValue(0)
  }, [eventsState.sports])

  const loadEvents = async () => {
    dispatch(toggleLoading())
    const where: FilterQuery<IEvent> | undefined = {}

    if (searchOptions?.text) {
      where.$or = [
        {
          'tournament.name': { $regex: searchOptions?.text, $options: 'i' }
        },
        {
          'participants.name': { $regex: searchOptions?.text, $options: 'i' }
        },
        {
          id: NumberUtils.onlyNumbers(searchOptions?.text)
        }
      ]
    }

    if (searchOptions?.sportId || searchOptions?.statusId || searchOptions?.dtIni || searchOptions?.dtFin) {
      where.$and = []

      if (searchOptions?.sportId) where.$and.push({ sport_id: searchOptions?.sportId })
      if (searchOptions?.statusId) where.$and.push({ status_id: searchOptions?.statusId })
      const dtIni = searchOptions?.dtIni?.toISOString()
      const dtFin = searchOptions?.dtFin?.toISOString()
      if (dtIni) where.$and?.push({ start_date: { "$gte": { type: 'Date', value: dtIni } } })
      if (dtFin) where.$and?.push({ start_date: { "$lte": { type: 'Date', value: dtFin } } })
    }

    const response = await dispatch(eventsStateLoadFromApi({
      where,
      onFinally: async () => {
        dispatch(toggleLoading())
        // IMPORTED METHOD...
        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
        // ...IMPORTED METHOD
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))

    if (!response.payload?.eventsApiGetResult?.payload?.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })
    }
  }

  const [gettingSports, setGettingSports] = useState<boolean>(false)
  const getSports = async (where?: FilterQuery<ISport> | undefined) => {
    if (gettingSports) return
    setGettingSports(true)

    try {
      const response = await new SportsApiClient(axios).get({
        where,
        sort: { name: 1 }
      })
      const sortedData = response.data?.payload?.sort((a, b) => a.name?.localeCompare(b.name))
      return sortedData
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingSports(false)
    }
  }

  const [gettingStatus, setGettingStatus] = useState<boolean>(false)
  const getStatus = async (filter: string) => {
    if (gettingStatus) return
    setGettingStatus(true)

    try {
      const response = await new EventsStatusApiClient(axios).get({
        where: {
          name: { $regex: filter, $options: 'i' }
        },
        sort: { name: 1 }
      })
      return response.data?.payload
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingStatus(false)
    }
  }

  const handleSportTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSportTabValue(newValue)

    // IMPORTED METHOD...
    if (tableComponentSetCurrPage)
      tableComponentSetCurrPage({
        page: 0
      })
    // ...IMPORTED METHOD
  }

  return <>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      paddingBottom: DEFAULTGAP
    }}>
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Eventos'
        onRefreshClick={loadEvents}
        onAddClick={() => navigate(RoutesNames.event)}
      />

      <SearchInputComponent
        style={{
          marginInline: DEFAULTGAP,
        }}
        label='Pesquisar por código, nome do time ou campeonato'
        onChange={e => setSearchOptions({
          ...searchOptions,
          text: e.target.value.trim()
        })}
        onKeyUp={e => { if (e.key === "Enter") loadEvents() }}
        onIconClick={loadEvents}
      />

      <FormStyled rowGap={DEFAULTGAP} columnGap={0}>
        <FormItemStyled gap={DEFAULTGAP}>
          <DropDownSearchComponent
            initInputValue={''}
            progress={gettingSports}
            label="Esporte"
            modelLabelName="name"
            dataBuilder={async (typedText: string | undefined) => {
              if (typedText)
                return await getSports({
                  name: { $regex: typedText, $options: 'i' }
                })
            }}
            onSelectItem={(item: ISport) => setSearchOptions({
              ...searchOptions,
              sportId: item.id
            })}
            onClear={() => setSearchOptions({
              ...searchOptions,
              sportId: undefined
            })}
          />
        </FormItemStyled>

        <FormItemStyled gap={DEFAULTGAP}>
          <DropDownSearchComponent
            initInputValue={''}
            progress={gettingStatus}
            label="Status"
            modelLabelName="name"
            dataBuilder={async (typedText: string | undefined) => {
              if (typedText)
                return await getStatus(typedText)
            }}
            onSelectItem={(item: IEventStatus) => setSearchOptions({
              ...searchOptions,
              statusId: item.id
            })}
            onClear={() => setSearchOptions({
              ...searchOptions,
              statusId: undefined
            })}
          />
        </FormItemStyled>
      </FormStyled>

      <FormStyled gap={DEFAULTGAP}>
        <FormItemStyled gap={DEFAULTGAP}>
          <DateTimePickerExtComponent
            ampm={false}
            label="Data Inicial"
            // to makes component empty, use null value. undefined not worked
            value={moment(searchOptions?.dtIni) || moment(eventsState.filter?.$and?.filter(and => and.start_date)[0]?.start_date?.$gte?.value) || null}
            onChange={(value: any) => {
              setSearchOptions({
                ...searchOptions,
                dtIni: value!
              })
            }}
          />
        </FormItemStyled>

        <FormItemStyled gap={DEFAULTGAP}>
          <DateTimePickerExtComponent
            ampm={false}
            label="Data Final"
            value={moment(searchOptions?.dtFin) || moment(eventsState.filter?.$and?.filter(and => and.start_date)[0]?.start_date?.$lte?.value) || null}
            onChange={(value: any) => {
              setSearchOptions({
                ...searchOptions,
                dtFin: value!
              })
            }}
          />
        </FormItemStyled>
      </FormStyled>

      {(eventsState.sports?.length || 0) > 1 ?
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={sportTabValue} onChange={handleSportTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs example">
            {eventsState.sports?.map((sport, idx) =>
              <Tab key={idx} label={`${sport.name}`} onClick={() => setCurrSportId(sport.id)} />
            )}
          </Tabs>
        </Box> : <></>}

      <TableComponent
        wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
        // IMPORTED METHOD...
        setCurrPageRef={tableComponentSetCurrPageRef}
        // ...IMPORTED METHOD
        bodyList={events.filter(e => e.sport_id === (currSportId || 0))}
        bodyRowBuilder={(event: IEvent) => <StyledTableCell style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center' }}>
          <StyledListItemText
            primary={event.participants.map((p, i) => <div key={i}>
              <EventsParticipantComponent rounded={currSportId == 12} defaultImg={currSportId == 12 ? imageDefaultAvatar : undefined} participant={p} />
            </div>)}
            secondary={
              <span style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 10
              }}>
                <label>{event.id}</label>
                <label>{moment(event.start_date).format('DD/MM/YYYY HH:mm:ss')}</label>
                <label style={{ fontStyle: 'italic' }}>{event?.tournament?.name}</label>
              </span>
            }
          />
          <IconButton style={{ height: 46, width: 46 }} size={'small'}
            onClick={() => {
              navigate(RoutesNames.event.replace(':id', event?.id.toString()))
            }}>
            <EditIcon />
          </IconButton>
        </StyledTableCell>}
      />
    </div >
  </>
}